module.exports = __webpack_public_path__ + "img/P150T_weapon_127.4216f0f1.png";